import styled from 'styled-components';
import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';

const ButtonBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #c9cfd7;
  background: #fff;
  height: 100%;
`;

const TitleButtonBoxStyled = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #c9cfd7;

  & > h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #0e141d;
  }

  & > h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #494c66;
  }

  & > svg {
    min-width: 40px;
  }
`;

const ButtonBoxContentStyled = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  height: 100%;

  & > p {
    color: #494c66;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
`;

const ButtonStyled = styled(Button)`
  && {
    max-width: 280px;
    min-height: 44px;
    margin: auto auto 0;
  }
`;

export {
  ButtonBoxStyled,
  TitleButtonBoxStyled,
  ButtonBoxContentStyled,
  ButtonStyled,
};
